<clr-header>
  <div class="branding">
    <a class="nav-link">
      <cds-icon shape="atom"></cds-icon>
      <span class="title">{{ title }}</span>
    </a>
  </div>

  <app-caaks-user-panel class="header-actions"></app-caaks-user-panel>
  <ng-template thirdPartyComponent></ng-template>
</clr-header>
